import { render, staticRenderFns } from "./DuplicateExpensesWarningModal.vue?vue&type=template&id=600ba801&"
import script from "./DuplicateExpensesWarningModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateExpensesWarningModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports